<template>
  <main id="main-content" class="facility" role="main">
    <div @click="sendSentry" v-if="!dataPublish" class="preview">
      この施設は公開されていません
    </div>
    <div class="fac-detail-wrapper container">
      <div class="fac-content">
        <kcs-facility-header
          :detail="dataDetail"
          :detailImages="dataImages"
          :shareUrls="dataShareUrls"
        />
        <div class="fac-body">
          <kcs-facility-summary
            :detail="dataDetail"
            :detailImages="dataImages"
          />
          <kcs-facility-access :detail="dataDetail" />
          <kcs-ads-facility-review-top />
          <kcs-review-list :detail="dataDetail" />
          <kcs-facility-social-timeline :detail="dataDetail" />
          <kcs-facility-panel
            v-if="isDisplayNearbyFacilityList"
            :facilities="dataFacilities"
            :is-btn="false"
            title="近隣の施設"
            summary="近隣の施設"
            div-class="nearby-facility"
            h2-class="page-title blue"
          />
          <kcs-facility-stay
            :stays="dataStays"
            :detail="dataDetail"
            v-if="isDisplayStayList"
          />
          <kcs-facility-eat
            :eats="dataEats"
            :detail="dataDetail"
            v-if="isDisplayEatList"
          />
          <kcs-recommend-summary
            v-if="isDisplaySummaryList"
            :title="
              `${dataDetail.name}は、こちらのイベントの会場としてよく利用されています`
            "
            :tags="dataSummaries"
          />
          <div class="fac-attention">
            <ul>
              <li>
                ※施設の情報は最新ではない可能性があります。必ず公式ホームページにて内容をご確認ください。
              </li>
              <li>
                ※施設紹介文に関しては、施設のホームページより一部転記しております。
              </li>
              <li>
                ※施設の口コミは、Google Mapの情報を利用しています。
                口コミの投稿はGoogle Mapに対しての投稿となります。
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="side-info">
        <kcs-banner />
        <kcs-facility-contact :detail="dataDetail" v-if="!$device.isMobile" />
        <kcs-facility-ticket
          :detail="dataDetail"
          v-if="!$device.isMobile && isDisplayTicketArea"
        />
        <kcs-event-regist :detail="dataDetail" v-if="!$device.isMobile" />
        <kcs-breadcrumbs :list="list" v-if="$device.isMobile" />
        <kcs-facility-list
          :facilities="dataFacilities"
          v-if="isDisplayAFewNearbyFacilityList"
        />
        <kcs-event-list
          :events="dataEvents"
          :detail="dataDetail"
          v-if="isDisplayEventsList"
        />
        <kcs-similar-type-list
          :detail="dataDetail"
          v-if="isDisplaySimilaryTypeList"
        />
        <kcs-similar-service-list
          :detail="dataDetail"
          v-if="isDisplaySimilaryServiceList"
        />
        <kcs-similar-city-list
          :city-list="dataCityList.facet.city"
          :detail="dataDetail"
          v-if="isDisplaySimilaryCityList"
        />
      </div>
    </div>
  </main>
</template>

<script>
import { mapGetters } from 'vuex'
import { createUrl } from '@/utils/create-url'
import { jsonLdSchema } from '@/utils/json-ld-schema'
import { methods } from '@/utils/methods'
import { pageResponse } from '@/utils/page-response'
import KcsFacilityHeader from '@/components/molecules/kcs-facility-header.vue'
import KcsFacilitySummary from '@/components/organisms/kcs-facility-summary.vue'
import KcsFacilityAccess from '@/components/organisms/kcs-facility-access.vue'
import KcsReviewList from '@/components/organisms/kcs-review-list.vue'
import KcsBanner from '@/components/molecules/kcs-banner.vue'
import KcsFacilityContact from '@/components/molecules/kcs-facility-contact.vue'
import KcsFacilityTicket from '@/components/molecules/kcs-facility-ticket.vue'
import KcsEventRegist from '@/components/molecules/kcs-event-regist.vue'
import KcsBreadcrumbs from '@/components/atoms/kcs-breadcrumbs.vue'
import KcsFacilityPanel from '@/components/organisms/kcs-facility-panel.vue'
import KcsFacilityList from '@/components/organisms/kcs-facility-list.vue'
import KcsFacilityStay from '@/components/organisms/kcs-facility-stay.vue'
import KcsFacilityEat from '@/components/organisms/kcs-facility-eat.vue'
import KcsEventList from '@/components/organisms/kcs-event-list.vue'
import KcsSimilarTypeList from '@/components/molecules/kcs-similar-type-list.vue'
import KcsSimilarServiceList from '@/components/molecules/kcs-similar-service-list.vue'
import KcsSimilarCityList from '@/components/molecules/kcs-similar-city-list.vue'
import KcsAdsFacilityReviewTop from '@/components/molecules/kcs-ads-facility-review-top.vue'
import KcsRecommendSummary from '@/components/molecules/kcs-recommend-summary.vue'
import KcsFacilitySocialTimeline from '~/components/molecules/kcs-facility-social-timeline.vue'
export default {
  components: {
    KcsFacilityHeader,
    KcsFacilitySummary,
    KcsFacilityAccess,
    KcsReviewList,
    KcsBanner,
    KcsFacilityContact,
    KcsFacilityTicket,
    KcsEventRegist,
    KcsBreadcrumbs,
    KcsFacilityPanel,
    KcsFacilityList,
    KcsFacilityStay,
    KcsFacilityEat,
    KcsEventList,
    KcsSimilarTypeList,
    KcsSimilarServiceList,
    KcsSimilarCityList,
    KcsAdsFacilityReviewTop,
    KcsRecommendSummary,
    KcsFacilitySocialTimeline
  },
  data() {
    return {
      dataDetail: {},
      dataImages: [],
      dataShareUrls: {},
      dataFacilities: [],
      dataEvents: [],
      dataPublish: true,
      dataTitle: '',
      dataMainPhoto: '',
      dataKeywords: '',
      dataDescription: '',
      dataJsonLd: {},
      dataLdEvent: {},
      dataSummaries: [],
      dataCityList: []
    }
  },
  head() {
    return {
      title: this.dataTitle,
      meta: [
        {
          hid: 'og-title',
          property: 'og:title',
          content: this.dataTitle
        },
        {
          hid: 'og-image',
          property: 'og:image',
          content: process.env.SITE_URL + this.dataMainPhoto
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: this.dataKeywords
        },
        {
          hid: 'description',
          name: 'description',
          content: this.dataDescription
        }
      ],
      script: [
        {
          type: 'application/ld+json',
          json: this.dataJsonLd
        },
        {
          type: 'application/ld+json',
          json: this.dataLdEvent
        }
      ]
    }
  },
  validate({ params }) {
    return params.id && /^\w+$/.test(params.id)
  },
  computed: {
    ...mapGetters({
      list: 'breadcrumb/list'
    }),
    // 近隣の施設エリアをKcsFacilityPanelで表示するかどうか
    isDisplayNearbyFacilityList() {
      return this.dataFacilities && this.dataFacilities.length >= 3
    },
    // 近隣の施設エリアをKcsFacilityListで表示するかどうか
    isDisplayAFewNearbyFacilityList() {
      return (
        this.dataFacilities &&
        this.dataFacilities.length > 0 &&
        this.dataFacilities.length < 3
      )
    },
    // 同じ収容人数の会議室を探すリンクエリアを表示するかどうか
    isDisplaySimilaryTypeList() {
      return this.dataDetail.event_type && this.dataDetail.event_type.length
    },
    // 同じ設備の会議室を探すリンクエリアを表示するかどうか
    isDisplaySimilaryServiceList() {
      return this.dataDetail.service && this.dataDetail.service.length
    },
    // 都道府県の貸し会議室を探すリンクエリアを表示するかどうか
    isDisplaySimilaryCityList() {
      return (
        this.dataCityList &&
        this.dataCityList.facet &&
        this.dataCityList.facet.city &&
        this.dataCityList.facet.city.length
      )
    },
    // 近隣の宿泊施設エリアを表示するかどうか
    isDisplayStayList() {
      return this.dataStays && this.dataStays.length > 0
    },
    // 近隣の飲食店エリアを表示するかどうか
    isDisplayEatList() {
      return this.dataEats && this.dataEats.length > 0
    },
    // イベント情報エリアを表示するかどうか
    isDisplayEventsList() {
      return this.dataEvents && this.dataEvents.length
    },
    // まとめ相互リンクを表示するかどうか
    isDisplaySummaryList() {
      return this.dataSummaries && this.dataSummaries.length
    },
    isDisplayTicketArea() {
      return this.dataDetail.pia
    }
  },
  async asyncData(context) {
    const apiNoCache = methods.isNoCacheQuery(context.query)
    const apiParams = {}
    if (apiNoCache) {
      apiParams.nocache = apiNoCache
    }
    const id = context.params.id

    await context.store
      .dispatch('middle_page/detail', { id, params: apiParams })
      .catch((e) => {
        pageResponse.error(context, e, '施設情報の取得に失敗しました')
        return false
      })

    // 施設詳細
    const facilityDetail = await context.store.getters['middle_page/detail']
    if (!facilityDetail.facility) {
      pageResponse.notFound(context, '施設情報が見つかりませんでした')
      return false
    }

    // 近隣の施設を取得
    const nearbyFacilityList = await context.store.getters[ // eslint-disable-line
      'middle_page/nearbyList'
    ] // eslint-disable-line

    // 付近のイベント取得
    const eventList = await context.store.getters['middle_page/eventList']
    // 付近の宿泊施設取得
    const stayList = await context.store.getters['middle_page/stayList']
    // 付近の飲食店取得
    const eatList = await context.store.getters['middle_page/eatList']
    // まとめ相互リンク取得
    const summaryList = await context.store.getters['middle_page/summaries']
    // 市区町村ファセット取得
    const cityList = await context.store.getters['middle_page/cityList']

    // jsonLd 生成
    const jsonLdEvent = jsonLdSchema.getJsonLdEvent(eventList)

    // 最近チェックした施設情報をセット
    context.store.dispatch('history/add', id)

    // meta.title をセット
    const title =
      facilityDetail.facility.name +
      '【' +
      facilityDetail.facility.prefecture +
      facilityDetail.facility.city +
      'のセミナー会場】 - ' +
      process.env.SITE_NAME

    // meta.og-image をセット
    const mainPhoto = methods.getPhotoUrl({
      photo: facilityDetail.facility.main_photo,
      id: facilityDetail.facility.id,
      width: 720,
      height: 540
    })

    // meta.keywords をセット
    let keywords =
      facilityDetail.facility.prefecture +
      ',' +
      facilityDetail.facility.city +
      ',' +
      facilityDetail.facility.tags.join(',')
    keywords += ',' + process.env.SITE_KEYWORDS
    // meta.description をセット（改行を削除）
    let description = facilityDetail.facility.introduction.replace(/\r?\n/g, '')
    if (description.slice(-1) !== '。') {
      description += '。'
    }
    description += process.env.SITE_DESCRIPTION

    // パンくず設定
    context.store.dispatch('breadcrumb/list', [
      { name: 'ホーム', url: '/' },
      { name: 'セミナー会場', url: '/s/' },
      {
        name: facilityDetail.facility.prefecture,
        url: createUrl.createSearchUrl({
          prefecture: facilityDetail.facility.prefecture
        })
      },
      {
        name: facilityDetail.facility.city,
        url: createUrl.createSearchUrl({
          prefecture: facilityDetail.facility.prefecture,
          city: facilityDetail.facility.city
        })
      },
      { name: facilityDetail.facility.name, url: context.route.path }
    ])

    // jsonLd 生成
    const jsonLdFacility = jsonLdSchema.getJsonLdFacility(
      facilityDetail.facility
    )

    // 非公開状態の場合は、ステータスコードを「404」にする
    let isPublish = true
    let statusCode = 200
    if (facilityDetail.facility.publish === 0) {
      isPublish = false
      statusCode = 404
    }

    const facilityDetailPageUrl =
      process.env.SITE_URL +
      createUrl.createFacilityUrl(facilityDetail.facility.code)

    // ページの出力成功
    pageResponse.success(context, statusCode)
    return {
      dataDetail: facilityDetail.facility,
      dataImages: facilityDetail.facility_images,
      dataShareUrls: {
        facebook: {
          url: facilityDetailPageUrl,
          share: true
        },
        twitter: {
          url: facilityDetailPageUrl,
          text: facilityDetail.facility.name,
          hashtags: ''
        }
      },
      dataFacilities: nearbyFacilityList.facilities,
      dataStays: stayList,
      dataEats: eatList,
      dataEvents: eventList,
      dataPublish: isPublish,
      dataTitle: title,
      dataMainPhoto: mainPhoto,
      dataKeywords: keywords,
      dataDescription: description,
      dataJsonLd: jsonLdFacility,
      dataLdEvent: jsonLdEvent,
      dataSummaries: summaryList.summaries,
      dataCityList: cityList
    }
  },
  mounted() {
    this.$ga.page({
      page: this.$route.path,
      title: this.$metaInfo.title,
      location: window.location.href
    })
  },
  methods: {
    sendSentry() {
      this.$sentry.captureException('この施設は公開されていません')
    }
  }
}
</script>
